module.exports = __webpack_public_path__ + "img/save-avatar-bg.c121f828.png";